<template>
  <div class="relative">
    <img
      src="@/assets/images/line/Vector 7.png"
      alt="lineimg"
      class="m-auto px-4"
    />
    <div class="absolute bg-design4 mob-hidden">
      <img
        src="../../../assets/images/bg-des/bgd4.svg"
        alt="bg-polygon"
        class=""
      />
    </div>
    <!-- <div class="absolute h-full lg:hidden md:hidden block w-full -mt-77px">
      <img
        src="../../../assets/images/line/cg-line-1-1.svg"
        alt="bg"
        class="w-full"
      />
    </div> -->
    <div
      class="md:w-5/6 absolute top-minus lg:w-5/6 w-full md:px-0 lg:px-0 px-4 mx-auto relative"
    >
      <div class="flex flex-wrap flexcolreverse">
        <div class="md:w-1/2 lg:w-1/2 w-full my-auto">
          <!-- <img
            src="../../../assets/images/abtus.jpg"
            class="w-full rounded-md border-2 border18px my-auto"
            alt=""
          /> -->
          <!-- src="https://www.youtube.com/embed/1nqY231kEnA" -->
          <iframe
            class="w-full rounded-md border-2 border18px my-auto"
            height="515"
            :src="link"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="md:w-1/2 lg:w-1/2 w-full my-auto md:pl-20 lg:pl-20 z-10">
          <p class="title sm-fsize16 md:font-normal lg:font-normal font-bold">
            <!-- About Us -->{{ heading }}
          </p>
          <p
            class="subtitle lg:pt-8 md:pt-8 lg:pt- 4 md:pt-4 pt-2 lh32px sm-fsize13 sm-lh26"
          >
            <span v-html="description"></span>
          </p>
          <!-- “There are only four kinds of people in the world. Those who have
        been caregivers. Those who are currently caregivers. Those who will
        be caregivers, and those who will need a caregiver.” ― Rosalyn
        Carter -->
          <p
            class="subtitle lg:pt-8 md:pt-8 lg:pt- 4 md:pt-4 pt-2 lh32px sm-fsize13 sm-lh26"
          >
            <!-- Nearly 190 mn in India have various incurable conditions and are
            dependent on family members for their daily care at home. Family
            caregivers of those navigating incurable illnesses or any other
            life-limiting conditions have unique challenges. Their inability to
            access reliable information, respite care, and emotional support
            creates trauma. -->
          </p>

          <p
            class="subtitle lg:pt-8 md:pt-8 lg:pt- 4 md:pt-4 pt-2 lh32px sm-fsize13 sm-lh26"
          >
            <!-- Caregiver Saathi™️ aims to empower family caregivers by creating an
            ecosystem of well-being and healing for the primary caregiver as
            well as for the care receiver. We provide them with the necessary
            guidance through educational content, tools, access to a community,
            support groups, and professional home-care services that can help
            them lead a fuller life. Caregiver Saathi also partners with
            professional caregivers, healthcare practitioners, care-service
            providers, employers, and well-wishers to build a supportive
            community to enable effective care. -->
          </p>

          <!--   <p class="subtitle lg:pt-6 md:pt-6 pt-3 lh32px sm-fsize14">
            This mission calls out to me as my dharma, my purpose. <br />
            ~ Bhavana Issar <br />
            Founder & CEO, Caregiver Saathi™
          </p> -->
        </div>
      </div>
      <div>
        <h4 class="title sm-fsize16 md:font-normal lg:font-normal font-bold">
          Friends of Caregiver Saathi
        </h4>
        <p class="subtitle pt-2 lh32px sm-fsize13 sm-lh26">
          Friends of Caregiver Saathi is a U.S.-based organization dedicated to
          supporting the vital work of the Caregiver Saathi Foundation in India.
          We are committed to empowering family caregivers across South Asia,
          with a special focus on women. Our mission is to alleviate the
          challenges faced by these caregivers by building a robust support
          system that enhances their emotional and mental resilience, and
          provides them with the agency to outsource necessary services. We
          enable and support on-the-ground initiatives that promote digital
          literacy, social-emotional literacy, mental health, and psycho-social
          support systems. Additionally, we focus on capacity building for
          facilitators, trainers, care attendants and volunteers who are
          integral to creating a sustainable and thriving care economy.
          Leveraging technology, we strive to make resources more accessible to
          caregivers, ensuring they have the tools and support needed to
          navigate the complexities of caregiving. Through our efforts, we aim
          to foster a compassionate, inclusive environment where family
          caregivers are empowered to lead healthier, more balanced lives. As a
          registered 501(c)(3) organization, donations are tax-deductible to the
          extent allowed by law.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  components: {},
  data() {
    return {
      heading: "",
      description: "",
      link: "",
    };
  },
  computed: {
    ...mapState("mainAboutUs", { aboutUs: "aboutUs" }),
    // heading() {
    //   return this.aboutUs.result[0].heading;
    // },
    // description() {
    //   return this.aboutUs.result[0].description;
    // },
    // link() {
    //   return this.aboutUs.result[0].link;
    // },
  },
  async mounted() {
    try {
      await this.$store
        .dispatch("mainAboutUs/getall_aboutUs")
        .then((result) => {
          this.heading = this.aboutUs.result[0].heading;

          this.description = this.aboutUs.result[0].description;

          this.link = this.aboutUs.result[0].link;
        })
        .catch((err) => {});
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
<style>
@media (min-width: 641px) {
  .top-minus {
    top: -70px;
  }
}
</style>
